import Header from "../components/Header"
import GameGrid from "../components/GameGrid"
import {useSeo} from '../hooks/useMetadata';
import "../assets/css/Game.css"
import GoftinoWidget from "../components/GoftinoWidget";
import React from "react";

export default function Games() {
    useSeo(
        'استودیو بازیسازی مدریک: بازیها',
        'به استودیوی بازیسازی مدریک خوش آمدید. فهرست بازیهای استودیو رو در اینجا مشاهده کنید',
        {keywords: 'medrick, game studio, mobile game'}
    );
    return (
        <>
            <Header title=" بی‌خیالش ! بازی کن"/>
            <GoftinoWidget />
            <GameGrid/>
        </>
    );
}
